import { Button, cn } from "@sfc/ui";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { forwardRef, type ComponentProps } from "react";

type StepNavigationButtonProps = Omit<
  ComponentProps<typeof Button>,
  | "children"
  | "variant"
  | "size"
  | "render"
  | "nativeButton"
  | "isLoading"
  | "aria-label"
> & {
  direction: "previous" | "next";
  label: string;
  iconOnly?: boolean;
};

/** Previous/next presentation; callers own ordering, bounds and pending state. */
export const StepNavigationButton = forwardRef<
  HTMLButtonElement,
  StepNavigationButtonProps
>(function StepNavigationButton(
  { direction, label, iconOnly = false, className, ...props },
  ref,
) {
  return (
    <Button
      {...props}
      ref={ref}
      type="button"
      variant="outline"
      size={iconOnly ? "icon" : "default"}
      aria-label={label}
      className={cn(
        "pointer-coarse:min-h-11 pointer-coarse:min-w-11",
        className,
      )}
    >
      {direction === "previous" && (
        <ChevronLeftIcon aria-hidden="true" className="size-4" />
      )}
      {!iconOnly && label}
      {direction === "next" && (
        <ChevronRightIcon aria-hidden="true" className="size-4" />
      )}
    </Button>
  );
});
